export const mapScreenSteerToTrack = (screenSteer: number): number => {
  const finiteSteer = Number.isFinite(screenSteer) ? screenSteer : 0;
  const normalizedSteer = Math.max(-1, Math.min(1, finiteSteer));
  return normalizedSteer === 0 ? 0 : -normalizedSteer;
};
